import Store from "../store";
import { openSelection } from "../utils/print";
import { getSheetIndex } from "../methods/get";
import { luckysheetrefreshgrid } from "../global/refresh";
import { getRangeAxis, getRangeByTxt, setRangeShow } from "../global/api";
import tooltip from "../global/tooltip";
import {
    hasProtectPermission,
    openProtectDialog,
    bindEvents,
    parsePermissionRules,
    drawDiagonalLines,
    openPreviewDrawer,
    broadcastCellProtect,
} from "../utils/cellProtection";
import luckysheetConfigsetting from "./luckysheetConfigsetting";
import server from "./server";

/**
 * @description 单元格保护控制器 其他无关业务的代码，都集成在 cellProtect.utils.js 中
 * @class
 */
class CellProtectionCtrl {
    constructor() {
        this.selectedRange = ""; // 选定的选区
    }

    /**
     * @description 绘制只读区域! 重要方法，请勿随意修改 [该方法在 drawMain 中调用，用于绘制只读区域]
     * @param {Object} options
     * @param {CanvasRenderingContext2D} options.tableCtx - Canvas 上下文
     * @param {number} options.offsetLeft - 偏移量
     * @param {number} options.offsetTop - 偏移量
     * @param {number} options.scrollWidth - 滚动宽度
     * @param {number} options.scrollHeight - 滚动高度
     */
    render(options = {}) {
        const { tableCtx, offsetLeft, offsetTop, scrollWidth, scrollHeight } = options;

        // 如果用户没有传递 tableCtx 则不处理
        if (!tableCtx) return;

        // 这里一定是从 当前 sheet index 获取的数据，因此，不需要重新过滤
        const ranges = this.patchRenderRangeArr();
        if (!ranges.length) return;

        ranges.forEach((item) => {
            // 这里保存的一定就是 range 形式： A1:B4 这种字符串，因为数据源是通过 getRangeByTxt 获取的
            let { range, sr = 0, sc = 0, er = 0, ec = 0 } = item;

            if (!range) return;

            // 将 'A1:B2' 转为数组'
            const { column, row } = getRangeByTxt(range);
            sr = row[0];
            sc = column[0];
            er = row[1] + 1;
            ec = column[1] + 1;

            let startX,
                startY,
                endX,
                endY = 0;

            // 绘制区域所受到的偏移影响是一致的
            const offsetX = offsetLeft - scrollWidth;
            const offsetY = offsetTop - scrollHeight;

            if (sc == 0) {
                startX = offsetX;
            } else {
                startX = Store.visibledatacolumn[sc - 1] + offsetX;
            }

            if (sr == 0) {
                startY = offsetY;
            } else {
                startY = Store.visibledatarow[sr - 1] + offsetY;
            }

            if (ec === 0) {
                endX = offsetX;
            } else {
                endX = Store.visibledatacolumn[ec - 1] + offsetX;
            }

            if (er === 0) {
                endY = offsetY;
            } else {
                endY = Store.visibledatarow[er - 1] + offsetY;
            }

            // 使用新的方法绘制斜线
            drawDiagonalLines(tableCtx, startX, startY, endX - startX, endY - startY);
        });
    }

    /**
     * @description 绘制单元格保护区域 - 跟当前登录用户相关
     * @returns {Array} 单元格保护区域数组 ["A1:B4", "D7:F11" ...]
     */
    patchRenderRangeArr(sheet_index) {
        // return [{ range: "A1:B4" }]; // 只需要返回对应的选区，那么，该选区就会被绘制斜线，表示该选区不可编辑
        // 获取当前用户的身份信息
        const cellProtectOptions = luckysheetConfigsetting.cellProtectOptions;

        // 如果用户没有对应的身份信息，则认定用户所有单元格都能编辑
        if (!cellProtectOptions || !cellProtectOptions.permissions) {
            return [];
        }

        // 不然从对象中解析当前用户信息
        const userInfo = cellProtectOptions.userInfo;
        const { depId, roleId, userId } = userInfo;

        // 如果当前用户是文档所有者，那么，其拥有该文档的所有编辑权限
        if (hasProtectPermission()) {
            return [];
        }

        // 开始判定 cellProtectConfig 中的权限
        let file = Store.luckysheetfile[sheet_index || getSheetIndex(Store.currentSheetIndex)];
        let cellProtectConfig = file.cellProtectConfig || [];

        // 如果没有配置单元格保护，则直接返回空
        if (!cellProtectConfig.length) return [];

        const protectedRanges = [];

        cellProtectConfig.forEach((item) => {
            const { range, mode, rules, otherUserPermission } = item;
            // 1. 如果是仅我可编辑，判定是否为所有者
            if (mode === "onlyme" && !hasProtectPermission() && otherUserPermission !== "edit") {
                // 这里还不能简单的禁止编辑哦，要看管理员给其他用户配置的什么权限？
                protectedRanges.push({ range, permission: otherUserPermission });
                return;
            }

            const canEdit = (rule) => rule.permission === "edit";

            // 2. 如果是指定用户权限，则需要根据 rules 规则进行匹配
            rules.forEach((rule) => {
                console.log(rule.depId, depId, rule.userId, userId);
                // 2.1 先看部门是否满足
                if (rule.depId === "all") {
                    // 所有部门的所有人 拥有 permission 权限
                    !canEdit(rule) && protectedRanges.push({ range, permission: rule.permission });
                }

                // 2.2 如果是同一个部门，并且部门内全部人员
                else if (rule.depId === depId && rule.userId === "all") {
                    !canEdit(rule) && protectedRanges.push({ range, permission: rule.permission });
                }

                // 2.3 如果是同一个部门，但是指定了用户
                else if (rule.depId === depId && rule.userId === userId) {
                    !canEdit(rule) && protectedRanges.push({ range, permission: rule.permission });
                }

                // 2.4 rules 没有匹配上，则需要判定 otherUserPermission 是否为 edit
                else if (otherUserPermission !== "edit") {
                    protectedRanges.push({ range, permission: otherUserPermission });
                }
            });
        });

        return protectedRanges;
    }

    /**
     * @description 处理保护操作 menuButton 点击事件回调
     * @param {*} itemvalue 选中的保护模式
     * @returns
     */
    handleProtect(itemvalue) {
        const hasPermission = hasProtectPermission();

        if (!hasPermission) {
            tooltip.info("温馨提示", "您没有权限进行单元格保护的配置");
            return;
        }

        // 如果用户指定当前单元格作为保护，则直接打开保护弹窗
        if (itemvalue === "current") {
            const [range] = getRangeAxis(getRangeByTxt());

            return this.permissionConfiguration(range);
        }

        // 否则唤起单元格选择器，用户可以选择要保护的单元格范围
        const range_default = Store.luckysheet_select_save[0];
        openSelection(range_default, ({ range }) => this.permissionConfiguration(range));
    }

    /**
     * @description 处理预览操作 menuButton 点击事件回调 （查看已保护范围）
     * @returns
     */
    handlePreview() {
        // 打开预览抽屉
        openPreviewDrawer();
    }

    /**
     * @description 拿到用户选区后，需要调用 openDialog 函数打开保护弹窗进行权限配置
     */
    permissionConfiguration(range = []) {
        // 打开保护弹窗
        openProtectDialog(range);
        // 保存当前选区范围
        this.selectedRange = range;
        // 绑定弹窗事件
        bindEvents(this.confirmHandler.bind(this));
    }

    /**
     * @description 单元格可编辑检测 - 用于 enter Edit 模式时，判定单元格是否可编辑
     * @param {*} row_index 行索引
     * @param {*} col_index 列索引
     * @param {*} sheet_index sheet 索引，默认当前 sheet
     * @returns {boolean} 是否可编辑 - true 表示可编辑，false 表示不可编辑
     */
    isEditable(row_index, col_index, sheet_index) {
        let editable = true;

        const ranges = this.patchRenderRangeArr(sheet_index);

        if (!ranges.length) return editable;

        // 不然需要判定传入的单元格是否已经被保护
        ranges.forEach((item) => {
            let { range, sr = 0, sc = 0, er = 0, ec = 0 } = item;

            if (range) {
                // 将 'A1:B2' 转为数组'
                const { column, row } = getRangeByTxt(range);
                sr = row[0];
                sc = column[0];
                er = row[1]; // 这里不能 + 1 哈
                ec = column[1]; // 这里不能 + 1 哈
            }
            if (row_index >= sr && row_index <= er && col_index >= sc && col_index <= ec && item.permission !== "edit") {
                editable = false;
            }
        });

        return editable;
    }

    /**
     * @description 确认事件回调
     */
    confirmHandler() {
        // 1. 如果是仅我可编辑，则不需要解析 rules ，直接置空即可 ,判定 .segmented-control 下那个 button 处于 active
        const mode = $("#mode-only-me.active").length > 0 ? "onlyme" : "specific";

        const cellProtectItem = {
            range: this.selectedRange,
            mode,
        };

        // 仅我可编辑 直接构建数据对象
        if (mode === "onlyme") {
            cellProtectItem.rules = [];
        } else if (mode === "specific") {
            cellProtectItem.rules = parsePermissionRules();
        }

        // 其他人员的权限 #other-user-permission-select 选中的值
        const otherUserPermission = $("#other-user-permission-select").val();
        cellProtectItem.otherUserPermission = otherUserPermission;

        // 2. 更新当前sheet的保护配置
        this.updateSheetFile(cellProtectItem);

        broadcastCellProtect(cellProtectItem, Store.currentSheetIndex, "add");

        // 刷新表格
        luckysheetrefreshgrid();
    }

    /**
     * @description 更新当前sheet的保护配置
     * @param {*} cellProtectItem 单元格保护配置
     * @param {*} sheet_index sheet 索引
     */
    updateSheetFile(cellProtectItem, sheet_index) {
        // 如果传入的 cellProtectItem 是指定人员权限，并且没有 rules ，则直接返回
        if (cellProtectItem.mode === "specific" && !cellProtectItem.rules.length) {
            return;
        }

        // 更新 sheet config 中
        let file = Store.luckysheetfile[getSheetIndex(sheet_index || Store.currentSheetIndex)];

        // 判定当前 sheet 有没有 cellProtectConfig 字段
        if (!file.cellProtectConfig) {
            file.cellProtectConfig = [];
        }

        // 这里直接查询是否有 range 相同的
        const rangeItem = file.cellProtectConfig.find((item) => item.range === cellProtectItem.range);

        if (!rangeItem) {
            file.cellProtectConfig.push(cellProtectItem);
        } else if (cellProtectItem.mode === "onlyme" || rangeItem.mode !== cellProtectItem.mode) {
            rangeItem.rules = cellProtectItem.rules;
            rangeItem.otherUserPermission = cellProtectItem.otherUserPermission;
            rangeItem.mode = cellProtectItem.mode;
        } else {
            cellProtectItem.rules.forEach((rule) => {
                const existingRule = rangeItem.rules.find((item) => item.depId === rule.depId && item.userId === rule.userId);
                if (existingRule) {
                    existingRule.permission = rule.permission;
                } else {
                    rangeItem.rules.push(rule);
                }
            });
        }
    }

    /**
     * @description 检测当前单元格是否可见 none 表示不可见，则不需要渲染单元格的文本
     * @param {*} r 单元格行索引
     * @param {*} c 单元格列索引
     * @returns {boolean} 是否可见 - true 表示可见，false 表示不可见
     */
    isVisible(r, c) {
        const cells = this.patchRenderRangeArr();
        // 不然判断当前 r c 处于哪个范围内，并且判断当前范围的权限

        let visible = true;

        // 不然需要判定传入的单元格是否已经被保护
        cells.forEach((item) => {
            let { range, sr = 0, sc = 0, er = 0, ec = 0 } = item;

            if (range) {
                // 将 'A1:B2' 转为数组'
                const { column, row } = getRangeByTxt(range);
                sr = row[0];
                sc = column[0];
                er = row[1]; // 这里不能 + 1 哈
                ec = column[1]; // 这里不能 + 1 哈
            }
            if (r >= sr && r <= er && c >= sc && c <= ec && item.permission === "none") {
                visible = false;
            }
        });
        return visible;
    }

    /**
     * @description 处理其他客户端广播的单元格保护消息
     * @param {*} data 单元格保护配置
     * @param {*} sheet_index sheet 索引
     */

    syncUpdate(item) {
        // 这里需要解析对应的参数： op sheet_index range
        const { i, v, op } = item;

        // 当前sheet index 的 cellprotectionConfig
        if (op === "add") {
            this.updateSheetFile(v, i);
        } else if (op === "del") {
            let file = Store.luckysheetfile[i];
            let cellProtectConfig = file.cellProtectConfig || [];

            if (cellProtectConfig.length) {
                cellProtectConfig = cellProtectConfig.filter((item) => item.range !== v.range);
                file.cellProtectConfig = cellProtectConfig;
            }
        }

        // 刷新表格
        luckysheetrefreshgrid();
    }
}

export const cellProtectionCtrl = new CellProtectionCtrl();
